import { render, staticRenderFns } from "./PrivacyPolicyNew.vue?vue&type=template&id=d8a9bd50&scoped=true&"
import script from "./PrivacyPolicyNew.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyNew.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PrivacyPolicyNew.vue?vue&type=style&index=1&id=d8a9bd50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a9bd50",
  null
  
)

export default component.exports